import { consoleApiSlice } from "./consoleApiSlice";

export const consoleBiApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBiActivityTrends: builder.query({
      query: ({ days = 90, startDate, endDate, brands, users, useProd = false } = {}) => {
        const params = new URLSearchParams();
        params.append("days", days.toString());
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        if (brands?.length) params.append("brand", brands.join(","));
        if (users?.length) params.append("user", users.join(","));
        params.append("use_prod", useProd.toString());
        return { url: `/bi/activity-trends?${params.toString()}`, method: "GET" };
      },
      providesTags: ["BiActivityTrends"],
    }),

    // Sessions (kind: "sessions"): Hub sessions + sessionized V1 activity, newest first.
    getBiUserActivity: builder.query({
      query: ({ startDate, endDate, brands, users, sources, limit = 1000, offset = 0, useProd = false } = {}) => {
        const params = new URLSearchParams();
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        if (brands?.length) params.append("brand", brands.join(","));
        if (users?.length) params.append("user", users.join(","));
        if (sources?.length) params.append("source", sources.join(","));
        params.append("limit", limit.toString());
        params.append("offset", offset.toString());
        params.append("use_prod", useProd.toString());
        return { url: `/bi/user-activity?${params.toString()}`, method: "GET" };
      },
      providesTags: ["BiUserActivity"],
    }),

    getBiBrandActiveUsers: builder.query({
      query: ({ startDate, endDate, brands, useProd = false } = {}) => {
        const params = new URLSearchParams();
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        if (brands?.length) params.append("brand", brands.join(","));
        params.append("use_prod", useProd.toString());
        return { url: `/bi/brand-active-users?${params.toString()}`, method: "GET" };
      },
      providesTags: ["BiBrandActiveUsers"],
    }),

    getBiActivityByWebsite: builder.query({
      query: ({ startDate, endDate, useProd = false } = {}) => {
        const params = new URLSearchParams();
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        params.append("use_prod", useProd.toString());
        return { url: `/bi/activity-by-website?${params.toString()}`, method: "GET" };
      },
      providesTags: ["BiActivityByWebsite"],
    }),

    getBiStats: builder.query({
      query: ({ useProd = false } = {}) => ({
        url: `/bi/stats?use_prod=${useProd}`,
        method: "GET",
      }),
      providesTags: ["BiStats"],
    }),

    // Raw Hub events of one session plus title lookups (`entities`) for the finding groups,
    // findings, runs, scans and agents they reference — drill-in from the sessions table.
    // Goes through the Console platform-proxy so the Platform admin token never reaches
    // the browser.
    getBiSessionEvents: builder.query({
      query: ({ sessionId, useProd = true }) => ({
        url: `/platform-proxy/api/v2/customer-events/session/${encodeURIComponent(sessionId)}/detail?use_prod=${useProd}`,
        method: "GET",
      }),
    }),

    getBiFilterOptions: builder.query({
      query: ({ useProd = false } = {}) => ({
        url: `/bi/filter-options?use_prod=${useProd}`,
        method: "GET",
      }),
      providesTags: ["BiFilterOptions"],
    }),
  }),
});

export const {
  useGetBiActivityTrendsQuery,
  useGetBiUserActivityQuery,
  useGetBiBrandActiveUsersQuery,
  useGetBiActivityByWebsiteQuery,
  useGetBiStatsQuery,
  useGetBiFilterOptionsQuery,
  useGetBiSessionEventsQuery,
} = consoleBiApiSlice;
